import React from 'react';
import { assest } from '../../Assest/Assest';

function LaserDentistry() {
  return (
    <div style={styles.container}>
      <img 
        src={assest.LaserDentistry} 
        alt="Laser Dentistry" 
        style={styles.image} 
      />
      <div style={styles.content}>
        <h2 style={styles.title}>Advanced Laser Dentistry for a Healthier Smile</h2>
        <p style={styles.text}>
          Laser dentistry is a cutting-edge solution for a variety of dental procedures, offering precise and minimally invasive 
          treatments. Using advanced laser technology, we can perform procedures with greater comfort, reduced pain, and faster 
          healing times compared to traditional methods.
        </p>
        <p style={styles.text}>
          Common laser dentistry treatments include gum reshaping, treatment for gum disease, teeth whitening, and removing decayed 
          tissue. These procedures are safe, effective, and suitable for patients of all ages.
        </p>
        <p style={styles.text}>
          Experience the benefits of modern dental care with our laser dentistry services. Whether you're seeking a cosmetic 
          improvement or treatment for a dental issue, our team is here to provide you with personalized, comfortable care.
          Book your consultation today to learn more about how laser dentistry can enhance your dental health!
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: '#f9f9f9',
    padding: '40px',
    borderRadius: '10px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.3s ease-in-out',
    maxWidth: '900px',
    margin: '0 auto',
    textAlign: 'center',
  },
  image: {
    width: '100%',
    maxWidth: '800px',
    height: 'auto',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.3s ease-in-out',
  },
  content: {
    marginTop: '30px',
  },
  title: {
    fontSize: '2.5rem',
    color: '#2e2e2e',
    fontWeight: '700',
    marginBottom: '20px',
  },
  text: {
    fontSize: '1.1rem',
    color: '#555',
    lineHeight: '1.7',
    maxWidth: '800px',
    margin: '0 auto',
    paddingBottom: '10px',
    transition: 'color 0.3s ease-in-out',
  },
};

export default LaserDentistry;
